import type { BundleOfferPackageOptionView } from 'selectors/offerPage/bundledOfferPageSelectors'

export const getBundlePropertiesFees = (bundleOffer: App.BundleOffer, packageView: BundleOfferPackageOptionView): Array<App.PropertyFeesDetails> => {
  const data: Array<App.PropertyFeesDetails> = []

  for (const option of packageView.options) {
    const offer = bundleOffer.bundledOffers[option.package.offerId]

    if (offer.property && option.propertyFees) {
      data.push({
        propertyName: offer.property.name,
        propertyFees: option.propertyFees ?? 0,
        dueAtPropertyMessage: offer.property.taxesAndFeesContent ? offer.property.taxesAndFeesContent : '',
      })
    }
  }

  return data
}
